<form [formGroup]="DrawingForm" autocomplete="off">
  <div class="row m-0 eip-pt-20">
      <div style="width: 20%;">
          <mat-form-field floatLabel="always" appearance="none">
              <mat-label>Active Status</mat-label>
              <mat-slide-toggle [disabled]="!isAdmin" color="primary" formControlName="DocumentStatus">
              </mat-slide-toggle>
              <textarea matInput hidden></textarea>
          </mat-form-field>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <mat-form-field style="width: 100%;">
              <mat-label>Document no or title</mat-label>
              <input matInput formControlName="Documet_no">
          </mat-form-field>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <EIPAutoComplete style="padding-right: 20px; width:28%;" ShowTextValueField='N' floatLabelOption="never" TextField="dedDescription"  ValueField="dedId" [clearValue]='clearDisciplineSelected' WaterMarkText="Select Discipline" [dataSource]='disciplineList' setId="ddDiscpId8" (valueChange)='changeDiscipline($event)' [IsCascading]='true' [defaultValue]="dedId">
          </EIPAutoComplete>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <button mat-button (click)="getDocumentList()" class="btn btn-primary" type="submit" id="btnEDMSave">{{Search}}</button>
      </div>
  </div>
</form>
<kendo-grid [kendoGridBinding]="DocumentList" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [pageable]="true" id="grvEDMMemberList">
  <ng-template kendoPagerTemplate>
      <div class="k-pager-left">
          <kendo-pager-info></kendo-pager-info>
      </div>
      <div class="k-pager-right">
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-input></kendo-pager-input>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
      </div>
  </ng-template>
  <ng-template kendoGridToolbarTemplate>
      <div class="k-grid-toolbar-content d-flex">
          <div class="flex-grow-1 mat-panel-headerbar"></div>

          <div class="divider-container d-none d-md-block" id="imgDivider">
              <span></span>
          </div>
          <div class="pagination-container">
              <p id="lblShowDetails">Show</p>
              <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
              </kendo-pager-page-sizes>
              <span>Items</span>
          </div>
          <div class="divider-container d-none d-md-block" id="imgDivider">
              <span></span>
          </div>
          <div class="icons-container">
              <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
              <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">

                  <div class="icon-wrap" (click)="toggleFilter()">
                      <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                      <span class="list-icon-name">Filter</span>
                  </div>

                  <div class="icon-wrap" (click)="toggleFullscreen()">
                      <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                      <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                  </div>
              </div>
              <div class="divider-container"><span></span></div>
              <i class="fa fa-edit icon-my-10" title="Update" aria-hidden="true" (click)="UpdateAllDocument()"></i>
          </div>
      </div>
  </ng-template>
  <kendo-grid-column width="30">
      <ng-template kendoGridHeaderTemplate let-dataItem>
          <span>
              <mat-checkbox (change)="handleHeaderCheckboxEvent($event)">
              </mat-checkbox>
              {{update_status}}
          </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          <mat-checkbox [checked]="dataItem.is_select" [(ngModel)]="dataItem.is_select">
          </mat-checkbox>
      </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Document No" field="document_no" width="100">
  </kendo-grid-column>
  <kendo-grid-column title="Document Title" field="document_title" width="100">
  </kendo-grid-column>
  <kendo-grid-column title="Document Type" field="document_type" width="100">
  </kendo-grid-column>
  <kendo-grid-column title="Created By" field="created_By" width="100">
  </kendo-grid-column>
  <kendo-grid-column title="Created On" field="created_On" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          {{dataItem.created_On|date:'dd-MMM-yyyy'}}
      </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Modified By" field="modified_By" width="100">
  </kendo-grid-column>
  <kendo-grid-column title="Modified On" field="modified_On" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          {{dataItem.modified_On|date:'dd-MMM-yyyy'}}
      </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Action" width="30">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
          <i style="padding-right:10px"  class="fa fa-edit icon-my-10" (click)="UpdateDocument(dataItem)" aria-hidden="true"  title="Update" id="btnEDMEdit"></i>
      </ng-template>
  </kendo-grid-column>
</kendo-grid>